import { splitByMentions } from '../../../../api/lib/mentions.js';

// **Κείμενο συνομιλίας με τις αναφορές επισημασμένες** (D44, ΛΑ-22).
//
// ⚠ **Ο ΚΑΝΟΝΑΣ ΤΗΣ ΑΝΑΓΝΩΡΙΣΗΣ ΕΙΝΑΙ ΕΝΑΣ, ΚΑΙ ΕΙΝΑΙ ΤΟΥ ΔΙΑΚΟΜΙΣΤΗ.** Το
// άρθρωμα εισάγεται από το `api/lib/mentions.js` — το ίδιο που αποφασίζει ποιος
// ειδοποιείται. Δεύτερη υλοποίηση εδώ θα ήταν αόρατη όσο συμφωνούσαν: η οθόνη θα
// υπογράμμιζε ένα όνομα που ο διακομιστής δεν μέτρησε ως αναφορά, ή το αντίστροφο,
// και **καμία από τις δύο περιπτώσεις δεν παράγει σφάλμα**. Η πρώτη λέει ψέματα
// στον συντάκτη· η δεύτερη κρύβει από τον αναγνώστη ότι τον φώναξαν.
//
// Ο φράχτης που το επιβάλλει είναι στατικός (`services/mentions.test.js`): διαβάζει
// το κείμενο αυτού του αρχείου και απαιτεί την εισαγωγή. Ίδιο πρότυπο με τον
// έλεγχο του ποσού χρηματοδότησης, που φυλάει την ίδια ιδιότητα ανάμεσα στη
// διαδικτυακή εφαρμογή και στην επέκταση (**D36**).
//
// ⚠ **ΤΟ ΧΡΩΜΑ ΔΕΝ ΕΙΝΑΙ Η ΠΛΗΡΟΦΟΡΙΑ.** Το `@` **μένει ορατό**: όποιος δεν
// διακρίνει το χρώμα διαβάζει την αναφορά ακριβώς όπως τη διαβάζει ο καθένας
// (WCAG 1.4.1, ΜΛΑ-11). Το ζεύγος `text-accent` πάνω σε `bg-accent-soft` είναι
// **ήδη** στα ελεγμένα ζεύγη αντίθεσης της παραγωγής σταθερών, στο κατώφλι 7:1 —
// δεν προστέθηκε ζεύγος για αυτή τη δουλειά.

/**
 * @param text  Το κείμενο, όπως το έγραψε ο άνθρωπος.
 *
 * Δεν δέχεται «ποιοι είναι μέλη»: η επισήμανση δείχνει **τι έγραψε ο συντάκτης**,
 * όχι ποιος ειδοποιήθηκε. Αναφορά σε μη μέλος δεν φτάνει ποτέ ως εδώ — το API την
 * απορρίπτει με 422 πριν αποθηκευτεί το κείμενο.
 */
export default function MentionText({ text, className = '' }) {
    const parts = splitByMentions(text);

    return (
        <span className={className}>
            {parts.map((part, index) =>
                part.type === 'mention' ? (
                    <b
                        // Ο δείκτης είναι θεμιτό κλειδί εδώ: τα τμήματα παράγονται
                        // από το ίδιο κείμενο, με σταθερή σειρά, και δεν
                        // αναδιατάσσονται ποτέ.
                        key={index}
                        className="rounded-sm px-0.5 font-semibold text-accent"
                    >
                        {part.value}
                    </b>
                ) : (
                    <span key={index}>{part.value}</span>
                )
            )}
        </span>
    );
}
